import React from 'react';

export default function EducationHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F8FFFE] to-[#E6F9F9] pt-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Main Headline */}
        <div className="max-w-4xl mx-auto mb-12">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-[#111111]">
            Education is the Foundation of Prevention.
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto mb-8">
            Diatomic Life Foundation builds oxygen literacy through books, newsletters, digital content, and community programs that make oxygen science simple and actionable.
          </p>
          <ul className="text-left max-w-xl mx-auto space-y-3">
            {[
              'Research-backed books and publications',
              'Newsletters and educational media',
              'Community workshops and camps',
              'Oxygen awareness initiatives',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3 text-gray-700 text-lg">
                <span className="mt-1 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-checkbox-circle-fill text-[#12B6B6] text-xl"></i>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center bg-white rounded-2xl p-6 shadow-sm">
            <div className="text-3xl md:text-4xl font-bold text-[#12B6B6] mb-2">500+</div>
            <div className="text-sm md:text-base text-gray-600">Communities Reached</div>
          </div>
          <div className="text-center bg-white rounded-2xl p-6 shadow-sm">
            <div className="text-3xl md:text-4xl font-bold text-[#12B6B6] mb-2">50K+</div>
            <div className="text-sm md:text-base text-gray-600">People Educated</div>
          </div>
          <div className="text-center bg-white rounded-2xl p-6 shadow-sm">
            <div className="text-3xl md:text-4xl font-bold text-[#12B6B6] mb-2">25</div>
            <div className="text-sm md:text-base text-gray-600">Educational Resources</div>
          </div>
          <div className="text-center bg-white rounded-2xl p-6 shadow-sm">
            <div className="text-3xl md:text-4xl font-bold text-[#12B6B6] mb-2">100+</div>
            <div className="text-sm md:text-base text-gray-600">Healthcare Centers</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-[#12B6B6]"></i>
      </div>
    </section>
  );
}
